import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42a58814"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pop-box"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "button" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "pop-box-more" }
const _hoisted_6 = ["data-id"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_ctx.list.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Card, {
          title: _ctx.list[0].title,
          icon: _ctx.list[0].icon,
          onRemove: _ctx.removePopBox,
          class: _normalizeClass('pop-box-body' + (_ctx.list[0].full ? ' full' : '')),
          style: _normalizeStyle('transform: translate(-50%, calc(-50% - ' + ((_ctx.list.length > 3 ? 3 : _ctx.list.length) * 10) + 'px))')
        }, {
          default: _withCtx(() => [
            (_ctx.list[0].html)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  innerHTML: _ctx.list[0].html
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.list[0].template), _mergeProps({
                  key: 1,
                  data: _ctx.list[0].data
                }, _ctx.list[0].templateValue), null, 16, ["data"])),
            _withDirectives(_createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list[0].button, (button, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass('ss-button' + (button.master == true ? ' master' : '')),
                  key: 'pop-box-btn' + index,
                  onClick: button.fun
                }, _toDisplayString(button.text), 11, _hoisted_4))
              }), 128))
            ], 512), [
              [_vShow, _ctx.list[0].button]
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.length, (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  "data-id": index,
                  key: 'pop-more-' + index,
                  class: _normalizeClass(index > _ctx.list.length - 1 ? 'hid' : ''),
                  style: _normalizeStyle('margin:-' + (2 * (index - 1)) + 'px ' + ((20 * index - 1) - (2 * (index - 1))) + 'px 0 ' + ((20 * index - 1) - (2 * (index - 1))) + 'px;')
                }, null, 14, _hoisted_6))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["title", "icon", "onRemove", "class", "style"]),
        _hoisted_7
      ]))
    : _createCommentVNode("", true)
}